import { statementOfBenefitsEditComponent } from './statement-of-benefits-edit.component';

export const statementOfBenefitsEdit = angular 
.module('components.statement-of-benefits.statementOfBenefitsEdit', [])
.component('statementOfBenefitsEdit', statementOfBenefitsEditComponent)
.config(($stateProvider) => {
    'ngInject',

    $stateProvider
    .state('statementOfBenefitsEdit', {
        parent: 'app',
        url: '/home/statement-of-benefits/edit',
        breadcrumbName: 'statement of benefits edit',
        parentState: 'statementOfBenefits',
        component: 'statementOfBenefitsEdit',
        resolve: {
            details(StatementOfBenefitsService) {
                'ngInject';

                return StatementOfBenefitsService.getDisclaimerInfo();
            }
        }
    })
})
.name;


// WEBPACK FOOTER //
// ./src/app/components/statement-of-benefits/statement-of-benefits-edit/statement-of-benefits-edit.module.js